export default from './follow-user-button-mobile';



// WEBPACK FOOTER //
// ./app/components/follow-user-button-mobile/index.js